import { ReportInput } from '@totem/components/billingRates/parameterTypes';
import { Filter } from '@totem/types/common';

export const buildReportFilters = (input: ReportInput) => {
  const paramFilters: Filter[] = [];
  if (
    typeof input.name !== 'undefined' &&
    input.name !== null &&
    input.name.trim() !== ''
  ) {
    paramFilters.push({
      field: 'name',
      operator: 'cscontains',
      values: [input.name],
    });
  }

  return paramFilters;
};
